import React, { useRef } from 'react';
import styled from 'styled-components';

import useParallaxEffect from '../../hooks/useParallaxEffect';

import { backgroundImages } from '../../atoms/backgroundImage';

const ParallaxGrid = ({ theme, loading = 'lazy', className }) => {
  const backgroundRef = useRef(null);
  useParallaxEffect(backgroundRef);

  return (
    <BackgroundImage
      ref={backgroundRef}
      theme={theme}
      className={`parallax-grid ${className || ''}`}
      loading={loading}
    />
  );
};

export default ParallaxGrid;

const GridMap = {
  light: backgroundImages['grid-light'].desktop,
  dark: backgroundImages['grid-dark'].desktop,
};

export const BackgroundImage = styled.div`
  position: absolute;
  inset: 0px;
  width: 100%;
  max-width: 1216px;
  height: 100%;
  background-image: url(${({ theme }) => GridMap[theme]});
  background-repeat: repeat;
  background-size: 100%;
  background-position: center;
  pointer-events: none;
  margin: 0px auto;
  z-index: 1;
`;
